import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';

export const PART_FLATFILE_HEADER: any[] = [
	{
		label: 'Record ID',
		key: 'id',
	},
	{
		label: 'OW Part ID',
		key: 'partId',
		validators: [{ validate: 'required' }],
	},
	{
		label: 'Name',
		key: 'name',
		alternates: ['Part Name'],
	},
	{
		label: 'Part Number',
		key: 'partNumber',
		alternates: ['Part Number'],
	},
	{
		label: 'Is Stocked',
		key: 'isStocked',
		type: 'checkbox',
		validators: [{ validate: 'required' }],
	},
	{
		label: 'On Hand Qty',
		key: 'onHandQuantity',
		validators: [
			{ validate: 'required' },
			{
				validate: 'regex_matches',
				regex: `d*`,
			},
		],
	},
	{
		label: 'Min Qty',
		key: 'minQuantity',
		validators: [
			{ validate: 'required' },
			{
				validate: 'regex_matches',
				regex: `d*`,
			},
		],
	},
	{
		label: 'Max Qty',
		key: 'maxQuantity',
		validators: [
			{ validate: 'required' },
			{
				validate: 'regex_matches',
				regex: `d*`,
			},
		],
	},
	{
		label: 'Aisle',
		key: 'aisle',
	},
	{
		label: 'Bay',
		key: 'bay',
	},
	{
		label: 'Level',
		key: 'level',
	},
	{
		label: 'Bin',
		key: 'bin',
	},
];

export const EQUIPMENT_FLATFILE_HEADER: any[] = [
	{
		label: 'Record ID',
		key: 'id',
	},
	{
		label: 'OW Equipment Type ID',
		key: 'equipmentId',
		validators: [{ validate: 'required' }],
	},
	{
		label: 'Name',
		key: 'name',
		alternates: ['Equipment Name'],
	},
	{
		label: 'Equipment Type ID',
		key: 'equipmentTypeId',
		alternates: ['Equipment ID'],
	},
	{
		label: 'Min Qty',
		key: 'minQuantity',
		validators: [
			{ validate: 'required' },
			{
				validate: 'regex_matches',
				regex: `d*`,
			},
		],
	},
	{
		label: 'Max Qty',
		key: 'maxQuantity',
		validators: [
			{ validate: 'required' },
			{
				validate: 'regex_matches',
				regex: `d*`,
			},
		],
	},
];

export const RECEIVED_EQUIPMENT_FLATFILE_HEADER: any[] = [
	{
		label: 'Record ID',
		key: 'id',
	},
	{
		label: 'OW Equipment Type ID',
		key: 'equipmentId',
		validators: [{ validate: 'required' }],
	},
	{
		label: 'Name',
		key: 'name',
		alternates: ['Equipment Name'],
	},
	{
		label: 'Serial Number',
		key: 'serialNumber',
		validators: [{ validate: 'required' }],
	},
	{
		label: 'Cost',
		key: 'cost',
	},
	{
		label: 'Is Rental',
		key: 'isRental',
		type: 'checkbox',
		validators: [{ validate: 'required' }],
	},
];

export const PART_MASTER_FLATFILE_HEADER: any[] = [
	{
		label: 'OW Part ID',
		key: 'id',
	},
	{
		label: 'Name',
		key: 'name',
		alternates: ['Part Name'],
	},
	{
		label: 'Part Number',
		key: 'partNumber',
		alternates: ['Part Number'],
		validators: [{ validate: 'required' }],
	},
	{
		label: 'Alias Part Number',
		key: 'aliasPartId',
		alternates: ['Alias Part Number'],
	},
	{
		label: 'Description',
		key: 'description',
	},
	{
		label: 'Manufacturer Name',
		key: 'manufacturerName',
	},
	{
		label: 'Manufacturer ID',
		key: 'manufacturerId',
	},
	{
		label: 'Unit of Measure',
		key: 'uomId',
		type: 'select',
		options: [
			{ label: 'each', value: 1 },
			{ label: 'box', value: 2 },
			{ label: 'pound', value: 3 },
		],
	},
	{
		label: 'Cost (USD)',
		key: 'cost',
		validators: [
			{
				validate: 'regex_matches',
				regex: `d*`,
			},
		],
	},
];

export const EQUIPMENT_MASTER_FLATFILE_HEADER: any[] = [
	{
		label: 'OW Equipment Type ID',
		key: 'id',
	},
	{
		label: 'Model Name',
		key: 'modelName',
		alternates: ['Equipment Name'],
		validators: [{ validate: 'required' }],
	},
	{
		label: 'Equipment Type ID',
		key: 'equipmentTypeId',
		alternates: ['Equipment Type ID'],
		validators: [{ validate: 'required' }],
	},
	{
		label: 'Description',
		key: 'description',
	},
	{
		label: 'Manufacturer Name',
		key: 'manufacturerName',
	},
	{
		label: 'Manufacturer ID',
		key: 'manufacturerId',
	},
	{
		label: 'Cost (USD)',
		key: 'cost',
		validators: [
			{
				validate: 'regex_matches',
				regex: `d*`,
			},
		],
	},
];

export const getFlatfileRecordForEquipmentLevel = (record = {}) => ({
	id: nullSafeGetOrElse('id', record, ''),
	equipmentId: nullSafeGetOrElse('equipment.id', record, '--'),
	name: nullSafeGetOrElse('equipment.modelName', record, '--'),
	equipmentTypeId: nullSafeGetOrElse('equipment.equipmentTypeId', record, '--'),
	onHandQuantity: nullSafeGetOrElse('onHandQuantity', record, 0),
	minQuantity: nullSafeGetOrElse('minQuantity', record, 0),
	maxQuantity: nullSafeGetOrElse('maxQuantity', record, 0),
});

export const getFlatfileRecordForReceivedEquipment = (record = {}) => ({
	id: nullSafeGetOrElse('id', record, ''),
	equipmentId: nullSafeGetOrElse('equipmentId', record, ''),
	name: nullSafeGetOrElse('name', record, '--'),
	serialNumber: nullSafeGetOrElse('serialNumber', record, ''),
	cost: nullSafeGetOrElse('cost', record, ''),
	isRental: nullSafeGetOrElse('isRental', record, false),
});

export const getFlatFileRecordForPartLevel = (record = {}) => ({
	id: nullSafeGetOrElse('id', record, ''),
	partId: nullSafeGetOrElse('part.id', record, '--'),
	name: nullSafeGetOrElse('part.name', record, '--'),
	partNumber: nullSafeGetOrElse('part.partNumber', record, '--'),
	isStocked: nullSafeGetOrElse('isStocked', record, false),
	onHandQuantity: parseInt(nullSafeGetOrElse('onHandQuantity', record, 0)),
	minQuantity: parseInt(nullSafeGetOrElse('minQuantity', record, 0)),
	maxQuantity: parseInt(nullSafeGetOrElse('maxQuantity', record, 0)),
	aisle: nullSafeGetOrElse('aisle', record, ''),
	bay: nullSafeGetOrElse('bay', record, ''),
	level: nullSafeGetOrElse('level', record, ''),
	bin: nullSafeGetOrElse('bin', record, ''),
});

export const getFlatfileRecordForPart = (record = {}) => ({
	id: nullSafeGetOrElse('id', record, ''),
	name: nullSafeGetOrElse('name', record, ''),
	partNumber: nullSafeGetOrElse('partNumber', record, ''),
	aliasPartId: nullSafeGetOrElse('aliasPartId', record, ''),
	description: nullSafeGetOrElse('description', record, ''),
	manufacturerName: nullSafeGetOrElse('manufacturerName', record, ''),
	manufacturerId: nullSafeGetOrElse('manufacturerId', record, ''),
	uomId: nullSafeGetOrElse('uomId', record, ''),
	cost: nullSafeGet('cost', record) ? parseFloat(nullSafeGet('cost', record)) : '',
});

export const getFlatfileRecordForEquipment = (record = {}) => ({
	id: nullSafeGetOrElse('id', record, ''),
	modelName: nullSafeGetOrElse('modelName', record, ''),
	equipmentTypeId: nullSafeGetOrElse('equipmentTypeId', record, ''),
	description: nullSafeGetOrElse('description', record, ''),
	manufacturerName: nullSafeGetOrElse('manufacturerName', record, ''),
	manufacturerId: nullSafeGetOrElse('manufacturerId', record, ''),
	cost: nullSafeGet('cost', record) ? parseFloat(nullSafeGet('cost', record)) : '',
});
